import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import api from '../../utils/api';
import usePermission from '../../hooks/usePermission';
import PERM from '../../constants/permissions';

const AdminSidebarLinks = ({ isCollapsed }) => {
  const [load, setLoad] = useState(false);
  const location = useLocation();
  const { can, canAny } = usePermission();

  // Per-item, menggantikan flag biner `hasFullAccess` lama (lihat plan RBAC
  // Fase C). Pola visual "abu-abu" (opacity-50 pe-none) DIPERTAHANKAN --
  // hanya sumber keputusannya yang berubah dari scope ke permission granular.
  // FAIL-CLOSED: usePermission() sudah menangani kasus permissions kosong.
  const dashboardDisabled = !can(PERM.DASHBOARD_VIEW);
  const registrationsDisabled = !can(PERM.REGISTRATIONS_VIEW);
  const batchDisabled = !can(PERM.BATCH_VIEW);
  const publicationDisabled = !can(PERM.PUBLICATION_VIEW);
  // Sebelumnya TIDAK PERNAH digating sama sekali (bug) -- selalu aktif
  // terlepas dari isOtherDisabled. RBAC menutup celah ini.
  const recommendationDisabled = !can(PERM.RECOMMENDATION_VIEW);
  const capacityBuildingDisabled = !can(PERM.CAPACITY_BUILDING_VIEW);
  const penilaianDisabled = !canAny([PERM.EVALUATION_VIEW, PERM.CLASSIFICATION_VIEW]);
  const attendanceDisabled = !can(PERM.ATTENDANCE_VIEW);
  const penggunaDisabled = !canAny([PERM.USERS_VIEW, PERM.MENTORS_VIEW]);
  const institutionsDisabled = !can(PERM.INSTITUTIONS_VIEW);
  const bumdesDisabled = !canAny([
    PERM.BUMDES_VIEW,
    PERM.BUMDES_PRESURVEY_VIEW,
    PERM.BUMDES_VECI_VIEW,
    PERM.BUMDES_LEADERSHIP_VIEW,
    PERM.BUMDES_BMC_VIEW,
  ]);
  const universitiesDisabled = !can(PERM.UNIVERSITIES_VIEW);
  const exportsDisabled = !can(PERM.EXPORTS_EXPORT);

  const isBatchActive = location.pathname.includes('/admin/batch')
    || location.pathname.includes('/admin/registrations-journey')
    || location.pathname.includes('/admin/program-sections');
  const isPenilaianActive = location.pathname.includes('/admin/students') || location.pathname.includes('/admin/classifications') || location.pathname.includes('/admin/certificates');
  const isKpiHsActive = location.pathname.includes('/admin/classifications') && !location.pathname.includes('/admin/classifications-bcf');
  const isKpiBcfActive = location.pathname.includes('/admin/classifications-bcf');
  const isPenggunaActive = location.pathname.includes('/admin/users') || location.pathname.includes('/admin/mentors');
  const isBumdesActive = location.pathname.includes('/admin/bumdes');

  const onHandleExports = async () => {
    setLoad(true);
    try {
      const data = await api.exportUsers({
        kepulangan: 'Mengajukan Kepulangan',
      });
      setTimeout(() => {
        window.open(data.url);
        setLoad(false);
      }, 500);
    } catch (error) {
      console.error(error);
      setLoad(false);
    }
  };

  return (
    <>
      {/* Dashboard */}
      <NavLink
        to={dashboardDisabled ? '#' : '/admin'}
        onClick={(e) => dashboardDisabled && e.preventDefault()}
        className={() => {
          if (dashboardDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return location.pathname === '/admin' || location.pathname === '/admin/'
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Dashboard' : ''}
      >
        <i className='bi bi-house-fill'></i>
        <span className='sidebar-collapsed-text'>Dashboard</span>
      </NavLink>

      {/* Pendaftaran */}
      <NavLink
        to={registrationsDisabled ? '#' : '/admin/registrations'}
        onClick={(e) => registrationsDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (registrationsDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Pendaftaran' : ''}
      >
        <i className='bi bi-box-arrow-in-right'></i>
        <span className='sidebar-collapsed-text'>Pendaftaran</span>
      </NavLink>

      {/* Batch Dropdown */}
      <div className={`${isCollapsed ? 'dropend' : 'dropdown'} ${batchDisabled ? 'opacity-50 pe-none' : ''}`}>
        <a
          href='/#'
          data-bs-toggle='dropdown'
          data-bs-boundary='viewport'
          data-bs-offset='0,0'
          data-bs-strategy='fixed'
          className={`sidebar-link dropdown-toggle text-decoration-none ${isBatchActive ? 'active text-white' : 'link-body-emphasis'}`}
          title={isCollapsed ? 'Batch' : ''}
        >
          <i className='bi bi-calendar3-range'></i>
          <span className='sidebar-collapsed-text'>Batch</span>
        </a>
        <ul
          className='dropdown-menu text-small shadow border-0 rounded-4 p-2'
          style={{ zIndex: 2050 }}
        >
          <li className='nav-item'>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Batch
            </div>
            <NavLink
              to='/admin/batch'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Daftar Batch
            </NavLink>
            <NavLink
              to='/admin/registrations-journey'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Perjalanan Registrasi
            </NavLink>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Master Program
            </div>
            <NavLink
              to='/admin/program-sections'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3'
                  : 'dropdown-item rounded-3 text-decoration-none'
              }
            >
              Tahapan Program
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Publikasi */}
      <NavLink
        to={publicationDisabled ? '#' : '/admin/publication'}
        onClick={(e) => publicationDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (publicationDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Publikasi' : ''}
      >
        <i className='bi bi-envelope-paper-fill'></i>
        <span className='sidebar-collapsed-text'>Publikasi</span>
      </NavLink>

      {/* Surat Rekomendasi */}
      <NavLink
        to={recommendationDisabled ? '#' : '/admin/recommendation-letter'}
        onClick={(e) => recommendationDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (recommendationDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Surat Rekomendasi' : ''}
      >
        <i className='bi bi-send-arrow-down-fill'></i>
        <span className='sidebar-collapsed-text'>Surat Rekomendasi</span>
      </NavLink>

      {/* Capacity Building */}
      <NavLink
        to={capacityBuildingDisabled ? '#' : '/admin/capacity-building'}
        onClick={(e) => capacityBuildingDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (capacityBuildingDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Capacity Building' : ''}
      >
        <i className='bi bi-smartwatch'></i>
        <span className='sidebar-collapsed-text'>Capacity Building</span>
      </NavLink>

      {/* Penilaian Dropdown */}
      <div className={`${isCollapsed ? 'dropend' : 'dropdown'} ${penilaianDisabled ? 'opacity-50 pe-none' : ''}`}>
        <a
          href='/#'
          data-bs-toggle='dropdown'
          data-bs-boundary='viewport'
          data-bs-offset='0,0'
          data-bs-strategy='fixed'
          className={`sidebar-link dropdown-toggle text-decoration-none ${isPenilaianActive ? 'active text-white' : 'link-body-emphasis'}`}
          title={isCollapsed ? 'Penilaian' : ''}
        >
          <i className='bi bi-hand-thumbs-up-fill'></i>
          <span className='sidebar-collapsed-text'>Penilaian</span>
        </a>
        <ul
          className='dropdown-menu text-small shadow border-0 rounded-4 p-2'
          style={{ zIndex: 2050 }}
        >
          <li className='nav-item'>
            <NavLink
              to='/admin/students/evaluations'
              className={({ isActive }) =>
                isActive || location.pathname.includes('/admin/students')
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Mahasiswa
            </NavLink>
            <NavLink
              to='/admin/classifications'
              className={
                isKpiHsActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              KPI Divisi (Hard-Skill)
            </NavLink>
            <NavLink
              to='/admin/classifications-bcf'
              className={
                isKpiBcfActive
                  ? 'dropdown-item active rounded-3'
                  : 'dropdown-item rounded-3 text-decoration-none'
              }
            >
              KPI Batch (PAT/CB/Kehadiran)
            </NavLink>
            <NavLink
              to='/admin/certificates'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mt-1'
                  : 'dropdown-item rounded-3 mt-1 text-decoration-none'
              }
            >
              Antrian Sertifikat
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Absensi */}
      <NavLink
        to={attendanceDisabled ? '#' : '/admin/attendances'}
        onClick={(e) => attendanceDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (attendanceDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Absensi' : ''}
      >
        <i className='bi bi-calendar-check'></i>
        <span className='sidebar-collapsed-text'>Absensi</span>
      </NavLink>

      {/* Pengguna Dropdown */}
      <div className={`${isCollapsed ? 'dropend' : 'dropdown'} ${penggunaDisabled ? 'opacity-50 pe-none' : ''}`}>
        <a
          href='/#'
          data-bs-toggle='dropdown'
          data-bs-boundary='viewport'
          data-bs-offset='0,0'
          data-bs-strategy='fixed'
          className={`sidebar-link dropdown-toggle text-decoration-none ${isPenggunaActive ? 'active text-white' : 'link-body-emphasis'}`}
          title={isCollapsed ? 'Pengguna' : ''}
        >
          <i className='bi bi-people'></i>
          <span className='sidebar-collapsed-text'>Pengguna</span>
        </a>
        <ul
          className='dropdown-menu text-small shadow border-0 rounded-4 p-2'
          style={{ zIndex: 2050 }}
        >
          <li className='nav-item'>
            <NavLink
              to='/admin/users'
              className={({ isActive }) =>
                isActive || location.pathname.includes('/admin/users')
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Mahasiswa
            </NavLink>
            <NavLink
              to='/admin/mentors'
              className={({ isActive }) =>
                isActive || location.pathname.includes('/admin/mentors')
                  ? 'dropdown-item active rounded-3'
                  : 'dropdown-item rounded-3 text-decoration-none'
              }
            >
              Mentor
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Lembaga */}
      <NavLink
        to={institutionsDisabled ? '#' : '/admin/institutions'}
        onClick={(e) => institutionsDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (institutionsDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Lembaga' : ''}
      >
        <i className='bi bi-building'></i>
        <span className='sidebar-collapsed-text'>Lembaga</span>
      </NavLink>

      {/* BUMDesa Dropdown */}
      <div className={`${isCollapsed ? 'dropend' : 'dropdown'} ${bumdesDisabled ? 'opacity-50 pe-none' : ''}`}>
        <a
          href='/#'
          data-bs-toggle='dropdown'
          data-bs-boundary='viewport'
          data-bs-offset='0,0'
          data-bs-strategy='fixed'
          className={`sidebar-link dropdown-toggle text-decoration-none ${isBumdesActive ? 'active text-white' : 'link-body-emphasis'}`}
          title={isCollapsed ? 'BUMDesa' : ''}
        >
          <i className='bi bi-shop'></i>
          <span className='sidebar-collapsed-text'>BUMDesa</span>
        </a>
        <ul
          className='dropdown-menu text-small shadow border-0 rounded-4 p-2'
          style={{ zIndex: 2050 }}
        >
          <li className='nav-item'>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Registrasi BUMDes
            </div>
            <NavLink
              to='/admin/bumdes'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Daftar BUMDes
            </NavLink>
            <NavLink
              to='/admin/bumdes/approval'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Persetujuan BUMDes
            </NavLink>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Pre Survey
            </div>
            <NavLink
              to='/admin/bumdes/pre-survey'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Hasil Pre-Survey
            </NavLink>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Survey VECI
            </div>
            <NavLink
              to='/admin/bumdes/survey-veci'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Dashboard VECI
            </NavLink>
            <NavLink
              to='/admin/bumdes/survey-veci/list'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Hasil Survey VECI
            </NavLink>
            <NavLink
              to='/admin/bumdes/survey-veci/award'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Penetapan Award
            </NavLink>
            <NavLink
              to='/admin/bumdes/survey-veci/ranking'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Pemeringkatan VECI
            </NavLink>
            <NavLink
              to='/admin/bumdes/survey-veci/heatmap'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Indikator & Heatmap
            </NavLink>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Survey Leadership
            </div>
            <NavLink
              to='/admin/bumdes/survey-leadership'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Dashboard Leadership
            </NavLink>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Business Model Canvas
            </div>
            <NavLink
              to='/admin/bumdes/bmc'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Daftar BMC
            </NavLink>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <div
              className='ps-3 py-1 extra-small text-muted fw-bold text-uppercase'
              style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}
            >
              Red Cloud
            </div>
            <NavLink
              to='/admin/bumdes/red-cloud'
              end
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Dashboard Red Cloud
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Universitas */}
      <NavLink
        to={universitiesDisabled ? '#' : '/admin/universities'}
        onClick={(e) => universitiesDisabled && e.preventDefault()}
        className={({ isActive }) => {
          if (universitiesDisabled) return 'sidebar-link text-decoration-none text-muted opacity-50 pe-none';
          return isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none';
        }}
        title={isCollapsed ? 'Universitas' : ''}
      >
        <i className='bi bi-building-fill-check'></i>
        <span className='sidebar-collapsed-text'>Universitas</span>
      </NavLink>

      {/* Exports */}
      <div className={`${isCollapsed ? 'dropend' : 'dropdown'} ${exportsDisabled ? 'opacity-50 pe-none' : ''}`}>
        <a
          href='/#'
          data-bs-toggle='dropdown'
          data-bs-boundary='viewport'
          data-bs-offset='0,0'
          data-bs-strategy='fixed'
          className='sidebar-link link-body-emphasis dropdown-toggle text-decoration-none'
          title={isCollapsed ? 'Exports' : ''}
        >
          <i className='bi bi-file-earmark-arrow-down-fill'></i>
          <span className='sidebar-collapsed-text'>Exports</span>
        </a>
        <ul
          className='dropdown-menu text-small shadow border-0 rounded-4 p-2'
          style={{ zIndex: 2050 }}
        >
          <li className='nav-item'>
            <button
              disabled={load}
              onClick={() => onHandleExports()}
              type='button'
              className='dropdown-item rounded-3'
            >
              {load && (
                <span className='spinner-border spinner-border-sm me-2'></span>
              )}
              <span>Mengajukan Kepulangan</span>
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default AdminSidebarLinks;
